import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';
import { getSftpExecutionModeDescriptions, getSftpImportQueueStatusDescriptions, SftpRecentRunHistory, SftpImportQueueStatus } from '../../../store/Models/Api/SftpImportModels';
import { ToxnotReactTable, TableColumn, TableRow } from '../../core/ToxnotReactTable';

interface RecentRunHistoryTableLocalProps {
    recentRuns: SftpRecentRunHistory[];
}

type RecentRunHistoryTableProps = RecentRunHistoryTableLocalProps & ToxnotComponentProperties;

class RecentRunHistoryTableComponent extends ToxnotComponent<RecentRunHistoryTableProps> {
    
    private getHeaderColumns = (): TableColumn<SftpRecentRunHistory>[] => {
        return [
            { value: this.localizeString("Start Time") },
            { value: this.localizeString("Execution Mode") },
            { value: this.localizeString("Execution Status") },
            { value: this.localizeString("File Processed") },
            { value: this.localizeString("Message") }
        ];
    };

    private getRowForTable = (run: SftpRecentRunHistory, rowIndex: number): TableRow => {
        const sftpImportQueueStatusDescriptions = getSftpImportQueueStatusDescriptions(this.props.appServices);
        const sftpExecutionModeDescriptions = getSftpExecutionModeDescriptions(this.props.appServices);
        
        return {
            cols: [
                run.executionDate,
                sftpExecutionModeDescriptions[run.executionMode],
                <span className={run.executionStatus === SftpImportQueueStatus.Queued ? "text-success" : "text-danger"}>
                    {sftpImportQueueStatusDescriptions[run.executionStatus]}
                </span>,
                run.filePath,
                run.errorMessage ?? this.localizeString("Configuration Queued Successfully")
            ]
        };
    };

    render() {
        const { recentRuns } = this.props;

        return (
            <div className="tn-section">
                <div className="tn-section-row">
                    <div className="tn-section-col-12">
                        <h3>{this.localizeString("Recent Run History")}</h3>
                        <ToxnotReactTable
                            headerRow={this.getHeaderColumns()}
                            allRowModels={recentRuns}
                            getRowForTable={this.getRowForTable}
                            localizer={this.props.appServices}
                            noResultFoundContent={this.localizeString("No recent runs found")}
                            enablePaging={false}
                            fullSectionWidth={true}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export const RecentRunHistoryTable = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(RecentRunHistoryTableComponent);
